import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 用来存储数据
const state = {
    headerTitle: '',
    headerText: '',
    navIndex: '',
    logoImage: ''
}
// 响应组件中的事件
const actions = {
    changeDispatch(context, data) {
        // console.log('actions', context, data);
        context.commit("changeCommit", data);
    },
    dispatchNavIndex(context, data) {
        // console.log('actions', context, data);
        context.commit("commitNavIndex", data);
    },
    dispatchImage(context, url) {
        // console.log('actions', context, data);
        context.commit("commitImage", url);
    }
}
// 操作数据
const mutations = {
    changeCommit(state, data) {
        // console.log("mutations", state, data);
        state.headerTitle = data.title
        state.headerText = data.text
    },
    commitNavIndex(state, data) {
        // console.log("mutations", state, data);
        state.navIndex = data
        // state.headerText = data.text
    },
    commitImage(state, url) {
        // console.log("mutations", state, url);
        state.logoImage = url
        // state.headerText = data.text
    }
}
// 用来将state数据进行加工
const getters = {

}
// 新建并暴露store
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})


// WEBPACK FOOTER //
// ./src/store/index.js